import { GeoCircle } from './geo-circle.model';
import { GeoBoundBox } from './geo-bound-box.model';
import { GeoPolygon } from './geo-polygon.model';
import { GeoSeachType } from '../enums/geo-search-type.enum';
import { Position } from './position.model';

export class GeneralInfoFilter {

    public searchType: GeoSeachType;
    public circle: GeoCircle;
    public boundingBox: GeoBoundBox;
    public multipolygon: GeoPolygon;
    public responseId?: string;
    public facilitiesIn?: string[];
    public starRatingIn?: number[];
    public carbonFootprintIn?: any[];
    public showOnMapRequestId?: string;
    public location?: Position;

    constructor(obj: Partial<GeneralInfoFilter>) {
        Object.assign(this, obj);
    }

}
